export const SET_TOKEN = 'SET_TOKEN';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_USER_ID = 'SET_USER_ID';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const LOGOUT = 'LOGOUT';
export const SET_CURRENT_EMAIL = 'SET_CURRENT_EMAIL';
